import http from './http';
import {PROJECT_BASE} from './paths';
import {withPerm} from './perm';

const BASE_URL = PROJECT_BASE;

// 프로젝트 메뉴 목록 조회
export const getProjectMenuList = withPerm(async (pjtId) => {
  const response = await http.get(`${BASE_URL}/${pjtId}/menu`);
  return response.data;
}, 'GET', `${BASE_URL}/{pjtId}/menu`);

// 프로젝트 메뉴 단건 조회
export const getProjectMenu = withPerm(async (pjtId, pjtMenuId) => {
  const response = await http.get(`${BASE_URL}/${pjtId}/menu/${pjtMenuId}`);
  return response.data;
}, 'GET', `${BASE_URL}/{pjtId}/menu/{pjtMenuId}`);

// 프로젝트 메뉴 생성
export const createProjectMenu = withPerm(async (pjtId, payload) => {
  const response = await http.post(`${BASE_URL}/${pjtId}/menu`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}, 'POST', `${BASE_URL}/{pjtId}/menu`);

// 프로젝트 메뉴 수정
export const updateProjectMenu = withPerm(async (pjtId, pjtMenuId, payload) => {
  const response = await http.put(`${BASE_URL}/${pjtId}/menu/${pjtMenuId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}, 'PUT', `${BASE_URL}/{pjtId}/menu/{pjtMenuId}`);

// 프로젝트 메뉴 삭제
export const deleteProjectMenu = withPerm(async (pjtId, pjtMenuId) => {
  const response = await http.delete(`${BASE_URL}/${pjtId}/menu/${pjtMenuId}`);
  return response.data;
}, 'DELETE', `${BASE_URL}/{pjtId}/menu/{pjtMenuId}`);

// 다건 삭제(헬퍼): 선택 삭제는 단건 삭제 병렬 처리
export const deleteProjectMenuBatch = async (pjtId, idList = []) => {
  if (!Array.isArray(idList)) throw new Error('idList must be an array');
  const tasks = idList.map((id) => deleteProjectMenu(pjtId, id));
  return Promise.all(tasks);
};

// 재정렬(헬퍼): commands = [{ menuId, parentMenuId, sortSeq }]
export const reorderProjectMenus = async (pjtId, commands = []) => {
  if (!Array.isArray(commands)) throw new Error('commands must be an array');
  const tasks = commands.map(cmd => updateProjectMenu(pjtId, cmd.menuId, { parentMenuId: cmd.parentMenuId ?? null, sortSeq: cmd.sortSeq }));
  return Promise.all(tasks);
};
